/**
 * Various treatment utilities.
 */
const manifest = require('manifest');

const currentCohortName = manifest.cohortName;

/**
 * Synchronously invoke the specified callback, if the
 * current cohort name is amongst the specified cohort name(s).
 *
 * The cohort names argument, can either be a single string, or an array of string.
 */
module.exports.doForCohortsNamed = (nameOrNames, callback) => {
  const cohortNames = (typeof nameOrNames === 'string' && nameOrNames.length > 0) ? [nameOrNames] : (Array.isArray(nameOrNames) ? nameOrNames : null);
  if (!cohortNames || cohortNames.length === 0) {
    throw new Error("Invalid argument. Please specify a string or an array.");
  }
  if (cohortNames.indexOf(currentCohortName) !== -1) {
    callback();
  }
};

module.exports.CONTROL = 'control';
module.exports.VARIATION1 = 'variation-1';
module.exports.VARIATION2 = 'variation-2';
module.exports.VARIATION3 = 'variation-3';
module.exports.VARIATION4 = 'variation-4';
module.exports.VARIATION5 = 'variation-5';
module.exports.VARIATION6 = 'variation-6';


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/treatment-utils.js